import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-xl transition-transform duration-200 hover:-translate-y-1 active:translate-y-0 text-center';
  const variants = {
    primary: 'bg-sage-600 text-white shadow-lg shadow-sage-600/30 hover:bg-sage-700',
    secondary: 'bg-[#e8a365] text-white shadow-lg shadow-[#e8a365]/30 hover:bg-[#d99254]',
    outline: 'border-2 border-sage-600 text-sage-700 hover:bg-sage-50'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClasses = `${baseStyles} ${variants[variant]} ${widthClass} ${className}`;
  if (href) {
    return <a href={href} className={combinedClasses} data-id="element-41">
        {children}
      </a>;
  }
  return <button className={combinedClasses} {...props} data-id="element-42">
      {children}
    </button>;
}